import { memo, useCallback } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import copy from 'copy-to-clipboard';

import { Icons, IconType } from '../../../../constants/icons';
import { AppToastInfoOption } from '../../../../constants/toast';
import { NameCard as NameCardCellProps } from '../../../../models/UserStore/NameCard';
import {
  NameCardCell,
  Skeleton,
  TextButton,
  TextButtonSize,
  TextButtonVariant,
} from '../../../Molecules';

import './SuccessCollectNameCardTemplate.css';

type SuccessCollectNameCardTemplateProps = {
  email: string;
  password: string;
  onClick: () => void;
  nameCard: NameCardCellProps | null | undefined;
};

export const SuccessCollectNameCardTemplate = memo(
  (props: SuccessCollectNameCardTemplateProps) => {
    const { t } = useTranslation();

    const { email, password, onClick, nameCard } = props;

    const onPressCopy = useCallback(() => {
      copy(password);
      toast(t('Password is copied.'), {
        ...AppToastInfoOption,
        id: 'clipboard',
      });
    }, [password, t]);

    return (
      <div>
        <div className="success-collect-name-card">
          <section>
            <div className="centered-container">
              <img className="tick-icon" src={Icons[IconType.Tick]} />
              <h3>{t('AI Name Card Collected')}</h3>
              {nameCard ? (
                <NameCardCell nameCard={nameCard} />
              ) : (
                <Skeleton
                  width={240}
                  height={360}
                  borderRadius={8}
                  style={{ boxShadow: '0 0 0.25rem #1D656B80' }}
                />
              )}

              <p className="text-sm" style={{ padding: '8px' }}>
                {t(
                  'You have collected the AI Name Card with the following email. A JOYAJOY account has been created for you!',
                )}
              </p>

              <div className="rounded-lg account-info">
                <div className="flex">
                  <img className="size-icon-m" src={Icons[IconType.Email]} />
                  <p>{t('Email: {email}', { email })}</p>
                </div>
                {password ? (
                  <div className="flex">
                    <img
                      className="size-icon-m"
                      src={Icons[IconType.Password]}
                    />
                    <p>{t('Password: {password}', { password })}</p>
                    <img
                      onClick={onPressCopy}
                      className="size-icon-s icon-button"
                      src={Icons[IconType.Copy]}
                    />
                  </div>
                ) : null}
              </div>
              <TextButton
                text={t('OK')}
                size={TextButtonSize.Small}
                variant={TextButtonVariant.Cyan}
                onClick={onClick}
              />
            </div>
          </section>
        </div>
      </div>
    );
  },
);
